import { useEffect } from "react";
import { Link } from "react-router-dom";
import { REGIONS } from "../lib/data/regions";
import { Reveal, RevealLines } from "../components/motion/Reveal";
import EditorialMarquee from "../components/site/EditorialMarquee";
import { setSEO } from "../lib/data/seo";

export default function Regions() {
  useEffect(() => {
    setSEO({
      title: "Security Services by BC Region — Metro Vancouver, Fraser Valley, Vancouver Island, Okanagan, Kootenays",
      description:
        "Regional security hubs across British Columbia — Metro Vancouver, Fraser Valley, Vancouver Island, Okanagan, Kootenays, Peace Region, Sea-to-Sky, Northern BC and more.",
      keywords: REGIONS.flatMap((r) => r.keywords),
      canonical: `${window.location.origin}/regions`,
    });
  }, []);

  return (
    <div className="pt-24">
      <section className="pt-16 md:pt-24 pb-16 bg-[#F4F4F0]" data-testid="regions-hero">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323]">
            Directory · Regions · {REGIONS.length}
          </div>
          <RevealLines
            lines={["Regional dispatch,", "one provincial team."]}
            className="mt-6 font-display text-6xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.9] text-[#060913]"
          />
          <p className="mt-10 max-w-2xl text-lg md:text-xl text-[#5C5F66] leading-relaxed">
            Every BC region has its own risk profile — coal mines in the
            Kootenays, LNG in Kitimat, wineries in the Okanagan, luxury resorts
            in Sea-to-Sky. We staff each one deliberately.
          </p>
        </div>
      </section>

      <EditorialMarquee items={["METRO VANCOUVER", "FRASER VALLEY", "VANCOUVER ISLAND", "OKANAGAN", "KOOTENAYS", "PEACE REGION", "NORTHERN BC", "SEA-TO-SKY", "CARIBOO"]} />

      <section className="bg-[#F4F4F0] py-16 md:py-24" data-testid="regions-grid">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {REGIONS.map((r, i) => (
              <Reveal key={r.slug} delay={i * 0.04}>
                <Link
                  to={`/regions/${r.slug}`}
                  data-testid={`region-card-${r.slug}`}
                  className="group relative block overflow-hidden border border-black/10 hover:border-[#D92323] transition-colors aspect-[16/10]"
                >
                  <img
                    src={r.image}
                    alt={r.name}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#060913]/85 via-[#060913]/35 to-transparent" />
                  <div className="relative h-full flex flex-col justify-between p-6 md:p-10 text-white">
                    <div className="font-mono text-[10px] tracking-[0.28em] uppercase opacity-80">
                      Region · {String(i + 1).padStart(2, "0")}
                    </div>
                    <div>
                      <h3 className="font-display text-3xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
                        {r.name}
                      </h3>
                      <p className="mt-3 text-sm md:text-base opacity-80 max-w-md">
                        {r.tagline}
                      </p>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
